var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff6e6e;opacity:0;}.b{fill:#3c3f45;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(-4 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18228.342-4194.687a.5.5,0,0,1-.354-.146l-3.246-3.246a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l2.893,2.893,8.424-8.424a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-8.777,8.777A.5.5,0,0,1,18228.342-4194.687Z",
    transform: "translate(-18215.107 4215.575)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOk);
export default __webpack_public_path__ + "static/media/icon-ok.8cb03e29.svg";
export { ForwardRef as ReactComponent };